import React from 'react';
import Moment from 'moment';

import InOutDashboardContext from '../../services/inOutDashboard/InOutDashboardContext';

import { isLoginUserPrimaryCompany } from '../../utilities/roleUtility';

import Styles from '../../styles/componentStyle/inOutDashboard/InOutDashboard.scss';

/**
 * 月次実績テーブル
 * */
export const MonthlyRecordTableLayout = () => {
  // 画面表示
  return (
    <InOutDashboardContext.Consumer>
      {({ state }) => (
        <div className={`${Styles.achievementTable} dashboard-table`}>
          {isLoginUserPrimaryCompany() && (
            <table className='dashboard-table__table'>
              <tbody>
                <tr className='dashboard-table__tr'>
                  <td className='dashboard-table__label'>
                    <div className='label'>
                      {Moment(
                        `${state.faceImageHistories.last_month}/01`,
                        'YYYY/MM/DD'
                      ).format(data.title.dateFormat)}
                    </div>
                  </td>
                  <td className='dashboard-table__content'>
                    <div className='content_left'>
                      {data.title.enteredCount}
                    </div>
                    <div className='content_right'>
                      {
                        state.faceImageHistories
                          .last_month_check_in_out_log_count
                      }
                      {data.count}
                    </div>
                  </td>
                </tr>
                <tr className='dashboard-table__tr'>
                  <td className='dashboard-table__label' />
                  <td className='dashboard-table__content'>
                    <div className='content_left'>
                      {data.title.registerImageCount}
                    </div>
                    <div className='content_right'>
                      {state.faceImageHistories.last_month_register_image_count}
                      {data.count}
                    </div>
                  </td>
                </tr>
                <tr className='dashboard-table__tr'>
                  <td className='dashboard-table__label'>
                    <div className='label'>
                      {Moment(
                        `${state.faceImageHistories.current_month}/01`,
                        'YYYY/MM/DD'
                      ).format(data.title.dateFormat)}
                    </div>
                  </td>
                  <td className='dashboard-table__content'>
                    <div className='content_left'>
                      {data.title.enteredCount}
                    </div>
                    <div className='content_right'>
                      {
                        state.faceImageHistories
                          .current_month_check_in_out_log_count
                      }
                      {data.count}
                    </div>
                  </td>
                </tr>
                <tr className='dashboard-table__tr'>
                  <td className='dashboard-table__label' />
                  <td className='dashboard-table__content'>
                    <div className='content_left'>
                      {data.title.registerImageCount}
                    </div>
                    <div className='content_right'>
                      {
                        state.faceImageHistories
                          .current_month_register_image_count
                      }
                      {data.count}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      )}
    </InOutDashboardContext.Consumer>
  );
};

// 定数
const data = {
  title: {
    dateFormat: 'MMM',
    enteredCount: '顔レコ利用者数累計',
    registerImageCount: '顔レコへの顔写真登録者数',
  },
  count: '人',
};



// WEBPACK FOOTER //
// ./src/components/tables/InOutDashboardMonthlyRecordTable.jsx